import { render, staticRenderFns } from "./AdvertSupplier.vue?vue&type=template&id=4ec473ac&"
import script from "./AdvertSupplier.vue?vue&type=script&lang=js&"
export * from "./AdvertSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports